import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { observable, computed } from 'mobx';
import { useRequest } from 'ahooks';
import { SchoolChannelId, SchoolImgId, getOmniData } from '@src/services/omni-api';
import Toast from '@src/components/toast';
import Video from '@src/components/video';
import $$tracker from '@src/tracker';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
class SchoolStore {
  page = 1;
  pageSize = 10;

  @observable schoolList;

  schoolBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false
    }
  });

  updateSlideTranslateY = () => {
    const slides = document.querySelectorAll('.main-group-35 .swiper-slide.icon');
    const activeSlideIdx = [...slides].findIndex(slide => slide.dataset.active === 'true');

    slides[activeSlideIdx].querySelector('.icon-inner').style.transform = 'translateY(0px)';
    if (activeSlideIdx < 2) {
      slides[2].querySelector('.icon-inner').style.transform = 'translateY(0px)';
    } else if (activeSlideIdx >= slides.length - 2) {
      slides[slides.length - 3].querySelector('.icon-inner').style.transform = 'translateY(0px)';
    }

    let prevSlides = [...slides].slice(0, activeSlideIdx);
    let nextSlides = [...slides].slice(activeSlideIdx + 1);
    if (activeSlideIdx < 2) {
      prevSlides = [...slides].slice(0, 2);
      nextSlides = [...slides].slice(3);
    } else if (activeSlideIdx >= slides.length - 2) {
      prevSlides = [...slides].slice(0, slides.length - 3);
      nextSlides = [...slides].slice(slides.length - 2);
    }
    prevSlides.reverse().forEach((slide, index) => (slide.querySelector('.icon-inner').style.transform = `translateY(${10 * (index + 1) + 10 * index}px)`));
    nextSlides.forEach((slide, index) => (slide.querySelector('.icon-inner').style.transform = `translateY(${10 * (index + 1) + 10 * index}px)`));
  };

  schoolTabBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      // 三个图片为一组展示，activeIndex 的图片永远在中间
      slidesPerView: 5,
      slidesPerGroup: 1,
      slideToClickedSlide: true,
      spaceBetween: 6,
      // 当前图片居中
      centeredSlides: true,
      centeredSlidesBounds: true,
      autoplay: false,
      // slidesPerView: 5,
      // spaceBetween: 0,
      // allowTouchMove: false,
      // speed: 300,
      // centeredSlides: true,
      loop: true
      // on: {
      //   slideNextTransitionStart: this.updateSlideTranslateY,
      //   slidePrevTransitionStart: this.updateSlideTranslateY
      // }
    }
  });

  @observable activeIndex = 0;

  @computed
  get currentSchool() {
    if (!this.schoolList || this.schoolList.length === 0) {
      return null;
    }
    return this.schoolList[this.activeIndex];
  }

  select(index) {
    this.activeIndex = index;
    // 同步大图轮播到对应门派
    this.schoolBaseSwiperStore.onChange(index);
    // 同步底部小图轮播，让当前门派 icon 居中
    this.schoolTabBaseSwiperStore.onChange(index);
  }

  onSchoolClick = item => {
    this.currentSchool = item;
  };

  playVideo = item => {
    const videoUrl = item?.click_video?.[0]?.url;
    if (!videoUrl) {
      Toast.info('敬请期待');
      return;
    }

    const { close } = Video.append({ src: videoUrl });
    this.cleanVideoUp = close;
  };

  getImgListAsync = () => {
    return getOmniData(SchoolChannelId, [
      {
        dataSourceId: SchoolImgId || '',
        page: this.page,
        perPage: this.pageSize
      }
    ])
      .then(res => {
        this.schoolList = res[SchoolImgId];
        if (res[SchoolImgId].result?.items) {
          this.schoolList = res[SchoolImgId].result?.items;
          // this.updateSlideTranslateY();
        }
      })
      .catch(error => {
        Toast.fail(error?.msg);
      });
  };
  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    this.getImgListRequest = useRequest(
      async () => {
        await this.getImgListAsync();
      },
      { manual: true }
    );

    useMount(async () => {
      this.getImgListRequest.run();
    });

    // 大图轮播变化时，联动更新当前门派和底部小图轮播
    useEffect(
      () => {
        const index = this.schoolBaseSwiperStore.activeIndex;
        this.activeIndex = index;
        this.schoolTabBaseSwiperStore.onChange(index);
        if (this.currentSchool && this.currentSchool?.title) {
          $$tracker.clickMenpai(this.currentSchool?.title);
        }
      },
      [this.schoolBaseSwiperStore.activeIndex, this.schoolList, this.currentSchool]
    );

    // 小图轮播变化时（用户点击左右箭头或滑动），同步更新当前门派和大图轮播
    useEffect(
      () => {
        const index = this.schoolTabBaseSwiperStore.activeIndex;
        if (index !== this.activeIndex) {
          this.activeIndex = index;
          this.schoolBaseSwiperStore.onChange(index);
          if (this.currentSchool && this.currentSchool?.title) {
            $$tracker.clickMenpai(this.currentSchool?.title);
          }
        }
      },
      [this.schoolTabBaseSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.schoolBaseSwiperStore.onChange(this.activeIndex);
        this.schoolTabBaseSwiperStore.onChange(this.activeIndex);
      },
      [this.activeIndex]
    );
  }
}

export default SchoolStore;
